import { render, staticRenderFns } from "./BackgroundSettings.vue?vue&type=template&id=e4c3a7ca&scoped=true&"
import script from "./BackgroundSettings.vue?vue&type=script&lang=js&"
export * from "./BackgroundSettings.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundSettings.vue?vue&type=style&index=0&id=e4c3a7ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c3a7ca",
  null
  
)

export default component.exports